import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LockOpenIcon from '@mui/icons-material/LockOpen';

/**
 * Confirm dialog for owner / GM / accountant unlocking a job from a pending unlock request.
 */
const UnlockJobConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  workOrder = null,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      if (loading) return;
      onClose?.();
    }}
    aria-labelledby="unlock-job-confirm-dialog-title"
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle id="unlock-job-confirm-dialog-title">
      Unlock Job
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        Unlock{workOrder ? ` work order ${workOrder}` : ' this job'}? The job
        will become editable again and any invoiced proposals for this job will
        be uninvoiced.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="warning"
        variant="contained"
        disabled={loading}
        startIcon={<LockOpenIcon />}
      >
        {loading ? 'Unlocking…' : 'Unlock'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnlockJobConfirmDialog;
